"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("@mui/material/styles");
var LineButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/LineButton"));
var Logo_1 = __importDefault(require("atomicComponents/atoms/Logo"));
var general_1 = require("utils/general");
var StyledLineButton = (0, styles_1.styled)(LineButton_1.default, { shouldForwardProp: (0, general_1.omitProps)('isSelected') })(function (_a) {
    var theme = _a.theme, _b = _a.isSelected, isSelected = _b === void 0 ? false : _b;
    return ({
        padding: theme.spacing(2),
        border: "1px solid ".concat(theme.palette.grey[300]),
        borderRadius: theme.shape.borderRadius,
        borderColor: isSelected ? theme.palette.primary.main : theme.palette.grey[300],
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        textAlign: 'left',
        height: theme.spacing(8),
        svg: { color: theme.palette.riverstone },
        img: { marginRight: theme.spacing(2) },
        ':hover:not(.Mui-disabled)': {
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.secondary.light,
            borderColor: theme.palette.primary.main,
            svg: { color: theme.palette.riverstone },
        },
        ' .MuiButton-startIcon': {
            marginRight: theme.spacing(2.25),
            marginLeft: 0,
            '&.MuiButton-iconSizeMedium >*:nth-of-type(1)': { fontSize: 20 },
            '&.MuiButton-iconSizeLarge >*:nth-of-type(1)': { fontSize: 32 },
        },
        '&.MuiButton-sizeLarge': {
            padding: theme.spacing(2.5),
            fontSize: 20,
            height: theme.spacing(10),
            borderRadius: theme.spacing(1),
            img: { marginRight: theme.spacing(2.25) },
        },
        '&.MuiButton-sizeSmall': {
            padding: theme.spacing(1.5),
            fontSize: 16,
            height: theme.spacing(5),
            borderRadius: theme.spacing(0.5),
            img: { marginRight: theme.spacing(1.5) },
        },
    });
});
var MainContainer = (0, styles_1.styled)('div', { shouldForwardProp: (0, general_1.omitProps)('size') })(function (_a) {
    var theme = _a.theme, size = _a.size;
    return ({
        color: theme.palette.charcoal,
        fontWeight: size === 'large' ? theme.typography.fontWeightMedium : theme.typography.fontWeightRegular,
        fontSize: size === 'large' ? 20 : 16,
        lineHeight: '20px',
    });
});
var SecondaryContainer = (0, styles_1.styled)('div', { shouldForwardProp: (0, general_1.omitProps)('size') })(function (_a) {
    var theme = _a.theme, size = _a.size;
    return (__assign({ color: theme.palette.riverstone, fontSize: size === 'large' ? 16 : 12, lineHeight: size === 'large' ? '20px' : '16px' }, size === 'large' && { paddingTop: theme.spacing(0.5) }));
});
var SelectButton = function (_a) {
    var logoUrl = _a.logoUrl, isSelected = _a.isSelected, label = _a.label, description = _a.description, size = _a.size, rest = __rest(_a, ["logoUrl", "isSelected", "label", "description", "size"]);
    return ((0, jsx_runtime_1.jsxs)(StyledLineButton, __assign({ isSelected: isSelected, fullWidth: true, color: "neutral", size: size }, rest, { children: [logoUrl && label && (0, jsx_runtime_1.jsx)(Logo_1.default, { size: size === 'large' ? 'xl' : 'lg', brand: { logoUrl: logoUrl, name: label } }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(MainContainer, __assign({ size: size }, { children: label })), description && (0, jsx_runtime_1.jsx)(SecondaryContainer, __assign({ size: size }, { children: description }))] })] })));
};
exports.default = SelectButton;
